import Clickable from '@/components/Clickable';
import { DataExporter } from 'helpers/exporters';
import csv from 'helpers/exporters/csv';
import pdf from 'helpers/exporters/pdf';
import xlsx from 'helpers/exporters/xlsx';

export default function ShareModalDefaultExports({ data }: { data: DataExporter }) {
  return (
    <>
      <Clickable onClick={() => csv(data)}>Download CSV</Clickable>
      <Clickable onClick={() => pdf(data)}>Download PDF</Clickable>
      <Clickable onClick={() => xlsx(data)}>Download XLSX</Clickable>
    </>
  );
}
